import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useTalononeExtendPromoCode, useTalononePromoResponse } from '@/hooks/talonone';
import { TalononeExtendPromoCodeModal } from '@/types/modal';
import TalonOneDatePicker from '@/components/molecules/common/TalononeDatePicker';
import { ErrorModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: TalononeExtendPromoCodeModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { client, promo, onClose, page, pageSize } = modal;

  const [date, setDate] = useState<string | null>(null);
  const { refetch } = useTalononePromoResponse(client.clientId, page, pageSize, true);

  const submitR = useTalononeExtendPromoCode();

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.talonone_extend.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.talonone_extend.title')}
        onClose={onClose}
      />
    );
  }

  const body = (
    <div className={styles.flex100}>
      <div className={styles.height05rem} />
      <div className={styles.text1rem}>
        <Trans
          i18nKey="modal.talonone_extend.body"
          values={{
            code: promo.code,
            email: client.email,
          }}
        />
      </div>
      <div className={styles.height05rem} />
      <div className={styles.height1rem} />
      <TalonOneDatePicker
        required={true}
        label={t('modal.talonone_extend.new_expiry_date')}
        selectedDate={date}
        startingDate={promo.expiryDateTime}
        setSelectedDate={setDate}
      />
      <div className={styles.height1rem} />
    </div>
  );

  return (
    <StandardModal
      title={t('modal.talonone_extend.title')}
      onClose={onClose}
      onSubmit={() =>
        submitR.mutate({
          campaignId: promo.campaign.id,
          expiryDateTime: date || '',
          couponCode: promo.code,
          clientId: client.clientId,
        })
      }
      submittable={submitR.kind !== 'Loading' && date != null}
      submitLabel={t('common.update').toUpperCase()}
      body={body}
      containerStyle={{ maxWidth: 500 }}
      modalName="talonone_extend"
    />
  );
};

export default View;
